import { render, staticRenderFns } from "./duibifenqubi.vue?vue&type=template&id=83c911b4&scoped=true&"
import script from "./duibifenqubi.vue?vue&type=script&lang=js&"
export * from "./duibifenqubi.vue?vue&type=script&lang=js&"
import style0 from "./duibifenqubi.vue?vue&type=style&index=0&id=83c911b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c911b4",
  null
  
)

export default component.exports